/**
 * authBootstrap.js
 *
 * P0 security: auth flows through the backend's httpOnly `mementa_token`
 * cookie. This module is imported once (side-effect) from App.js and shims
 * `window.fetch` so every request includes `credentials: 'include'`,
 * meaning the cookie is always sent without each call site having to know.
 *
 * Previously this also stripped stale "Bearer null" / "Bearer undefined"
 * Authorization headers produced by ~91 legacy `localStorage.getItem('token')`
 * reads. Those reads have all been swept (Feb 2026) so the strip logic was
 * removed. The remaining `credentials: 'include'` shim is the only thing
 * keeping admin/consumer pages authenticated.
 */
const _originalFetch = window.fetch.bind(window);

window.fetch = (input, init) => {
  const opts = init ? { ...init } : {};
  if (opts.credentials === undefined) {
    opts.credentials = 'include';
  }
  return _originalFetch(input, opts);
};

export {};
